export const DeviationDocumentType = {
	DOCUMENTS: "documents",
	IMAGES: "images",
	VIDEOS: "videos",
	OTHER: "other_documents",
};